import { render, staticRenderFns } from "./gatewayincorrectpositionmodal.vue?vue&type=template&id=b2e78a60"
import script from "./gatewayincorrectpositionmodal.vue?vue&type=script&lang=js"
export * from "./gatewayincorrectpositionmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports